// @flow

import * as React from 'react';

import { Link } from '@ta/common.routing';
import { InteractionLogger } from '@ta/tracking.interactions';
import { ResponsiveImage } from '@ta/media.image';
import { localize, globalize } from '@ta/common.i18n';

import styles from './ShelfFilterSection.less';

type Props = {
  filterItem: any,
};

const ShelfFilterSection = (props: Props) => {
  const { filterItem } = props;
  const { url, thumbnail, title, count } = filterItem;
  return (
    <InteractionLogger>
      {logFeedClick => (
        <div>
          <Link href={url} onClick={e => logFeedClick(e, 'feedClick')} className="ui_poi_thumbnail">
            <div className={styles.photo_wrap}>
              <ResponsiveImage sources={thumbnail.photoSizes} width="100%" height="100%" />
            </div>
          </Link>
          <Link
            href={url}
            className={`item poi_name ui_link ${styles.text}`}
            onClick={e => logFeedClick(e, 'feedClick')}
          >
            <span className={styles.name}>
              {localize('hotels.type_and_count', {
                '0': title,
                '1': globalize.formatNumber('integer', count),
              })}
            </span>
          </Link>
        </div>
      )}
    </InteractionLogger>
  );
};

export default ShelfFilterSection;
